export default {
  container: 'min-h-[400px] h-[calc(100vh-210px)] overflow-auto p-3',
  finalTabContainer:
    'flex w-full min-h-[400px] h-[calc(100vh-210px)] justify-center mt-1 gap-6 outline-8 ',
  errorBox:
    'w-[50%] h-fit p-[10px] bg-red-200 text-red-800 border border-red-900 rounded-sm',
  errorHeading: 'font-medium! text-black!',
  listStyle: 'list-disc list-inside',
  successMessageBox:
    'w-[70%] h-fit p-[10px] flex justify-center items-center flex-col bg-green-200 text-green-800 border rounded-sm!',
  successHeadingBox:
    'flex items-center justify-center gap-2 font-semibold! text-[40px]!',
  circleIconStyle: 'text-[40px]!',
  successDescription: 'font-medium! text-xl!',
  nameTitle: 'text-sm! font-medium!',
  nameValue: 'max-w-[350px]',
  nextBtn: 'flex w-full justify-center mt-1',
  btnBox: 'flex w-full justify-center mt-1 gap-6',
  uploadDocStyle: 'p-2 bg-[#d9edf7] text-center cursor-pointer',
  fileBox: 'flex gap-2 items-center',
  cancelIcon: 'text-red-500 cursor-pointer',
};
